import { AxiosInstance } from 'axios';
import { MANAGER_API_ENDPOINT } from '@/constant';
import AbsentUseKindRepository from '@/repository/manager/absentUseKind/absentUseKindRepository';
import AccountTransferAlertRepository from '@/repository/manager/accountTransfer/accountTransferAlertRepository';
import AdministratorsRepository from '@/repository/manager/administrators/administratorsRepository';
import CompanyDrivenSettingRepository from '@/repository/manager/attendance/CompanyDrivenSettingRepository';
import AdministratorAttendancesRepository from '@/repository/manager/administratorAttendances/administratorAttendancesRepository';
import AgenciesRepository from '@/repository/manager/agencies/agenciesRepository';
import AgreeToVideoStreamingTermsRepository from '@/repository/manager/video/agreeToVideoStreamingTermsRepository';
import AuthRepository from '@/repository/manager/auth/authRepository';
import MembersRepository from '@/repository/manager/members/membersRepository';
import WhereaboutsCheckSettingRepository from '@/repository/manager/whereaboutsCheck/whereaboutsCheckSettingRepository';
import TopicsRepository from '@/repository/manager/topics/topicsRepository';
import TopicInsidesRepository from '@/repository/manager/topicInsides/topicInsidesRepository';
import MeRepository from '@/repository/manager/me/meRepository';
import PlansRepository from '@/repository/manager/plans/plansRepository';
import SchedulesRepository from '@/repository/manager/schedules/schedulesRepository';
import CommentsRepository from '@/repository/manager/comments/commentsRepository';
import CommunicationBookDisplayAdministratorRepository from '@/repository/manager/communicationBookDisplayAdministrator/communicationBookDisplayAdministratorRepository';
import CategoriesRepository from '@/repository/manager/categories/categoriesRepository';
import MealPatternsRepository from '@/repository/manager/mealPatterns/mealPatternsRepository';
import ServiceGroupsRepository from '@/repository/manager/serviceGroups/serviceGroupsRepository';
import ServiceOptionsRepository from '@/repository/manager/serviceOptions/serviceOptionsRepository';
import GroupsRepository from '@/repository/manager/groups/groupsRepository';
import SleepingConditionRepository from '@/repository/manager/dailyCheck/SleepingConditionRepository';
import SleepingRemarksRepository from '@/repository/manager/sleepingRemarks/sleepingRemarksRepository';
import RoleRepository from '@/repository/manager/role/roleRepository';
import FacilityRepository from '@/repository/manager/facility/FacilityRepository';
import OutsourcingRepository from '@/repository/manager/outsourcing/outsourcingRepository';
import AccidentReportRepository from '@/repository/manager/accident/accidentReportRepository';
import BillConfigurationRepository from '@/repository/manager/bills/billConfigurationRepository';
import BillsTotalRepository from '@/repository/manager/bills/billsTotalRepository';
import BillsConfirmRepository from '@/repository/manager/bills/billsConfirmRepository';
import CommunicationNotebooksRepository from '@/repository/manager/childcare-document/CommunicationNotebooksRepository';
import { topicInsideRepositoryImpl } from '@/repository/manager/childcare-document/TopicInsideRepository';
import { personalReportsRepositoryImpl } from '@/repository/manager/childcare-document/PersonalReportsRepository';
import SystemTroubleContactSettingRepository from '@/repository/manager/communications/SystemTroubleContactSettingRepository';
import PhotoRetailPriceRepository from './parentSales/PhotoRetailPriceRepository';
import PhotoPriceSettingRulesRepository from './parentSales/PhotoPriceSettingRulesRepository';
import FeatureRepository from '@/repository/manager/feature/FeatureRepository';
import CustomPlanReportsRepository from '@/repository/manager/customPlanReports/CustomPlanReportsRepository';
import {
  whereaboutsCheckResultRepository,
  whereaboutsCheckStatusRepository,
} from '@/repository/manager/whereaboutsCheck';
import FacilityCapacityRepository from '@/repository/manager/facility/FacilityCapacityRepository';
import PhotoBasePriceRepository from '@/repository/manager/parentSales/PhotoBasePriceRepository';
import ChildrenRepository from '@/repository/manager/facility/ChildrenRepository';
import TlnkOptionsRepository from '@/repository/manager/tlnk/TlnkOptionsRepository';
import MediaSelectorRepository from '@/repository/manager/tlnk/MediaSelectorRepository';
import CurriculumsRepository from '@/repository/manager/childcare-document/plan/CurriculumsRepository';
import YearsRepository from '@/repository/manager/childcare-document/plan/YearsRepository';
import MonthliesRepository from '@/repository/manager/childcare-document/plan/MonthliesRepository';
import WeekliesRepository from '@/repository/manager/childcare-document/plan/WeekliesRepository';
import StatusesRepository from '@/repository/manager/childcare-document/plan/StatusesRepository';
import ConditionsRepository from '@/repository/manager/childcare-document/sleepings/ConditionsRepository';

export default (axios: AxiosInstance) => {
  const absentUseKindRepository = AbsentUseKindRepository(axios);
  const accountTransferAlertRepository = AccountTransferAlertRepository(axios);
  const administratorsRepository = AdministratorsRepository(axios);
  const companyDrivenSettingRepository = CompanyDrivenSettingRepository(axios);
  const administratorAttendancesRepository = AdministratorAttendancesRepository(axios);
  const agenciesRepository = AgenciesRepository(axios);
  const agreeToVideoStreamingTermsRepository = AgreeToVideoStreamingTermsRepository(axios);
  const authRepository = AuthRepository(axios);
  const membersRepository = MembersRepository(axios);
  const topicsRepository = TopicsRepository(axios);
  const whereaboutsCheckSettingRepository = WhereaboutsCheckSettingRepository(axios);
  const topicInsidesRepository = TopicInsidesRepository(axios);
  const meRepository = MeRepository(axios);
  const plansRepository = PlansRepository(axios);
  const curriculumsPlanRepository = CurriculumsRepository(axios);
  const yearsPlanRepository = YearsRepository(axios);
  const monthliesPlanRepository = MonthliesRepository(axios);
  const weekliesPlanRepository = WeekliesRepository(axios);
  const planStatusesRepository = StatusesRepository(axios);
  const conditionsRepository = ConditionsRepository(axios);
  const schedulesRepository = SchedulesRepository(axios);
  const commentsRepository = CommentsRepository(axios);
  const communicationBookDisplayAdministratorRepository = CommunicationBookDisplayAdministratorRepository(axios);
  const categoriesRepository = CategoriesRepository(axios);
  const mealPatternsRepository = MealPatternsRepository(axios);
  const serviceGroupsRepository = ServiceGroupsRepository(axios);
  const serviceOptionsRepository = ServiceOptionsRepository(axios);
  const groupsRepository = GroupsRepository(axios);
  const sleepingConditionRepository = SleepingConditionRepository(axios);
  const sleepingRemarksRepository = SleepingRemarksRepository(axios);
  const roleRepository = RoleRepository(axios);
  const facilityRepository = FacilityRepository(axios);
  const outsourcingRepository = OutsourcingRepository(null);
  const accidentReportRepository = AccidentReportRepository(axios);
  const billConfigurationRepository = BillConfigurationRepository(axios);
  const billsTotalRepository = BillsTotalRepository(axios);
  const billsConfirmRepository = BillsConfirmRepository(axios);
  const communicationNotebooksRepository = CommunicationNotebooksRepository(axios);
  const systemTroubleContactSettingRepository = SystemTroubleContactSettingRepository(null);
  const photoRetailPriceRepository = PhotoRetailPriceRepository(axios);
  const photoPriceSettingRulesRepository = PhotoPriceSettingRulesRepository(axios);
  const photoBasePricesRepository = PhotoBasePriceRepository(axios);
  const featureRepository = FeatureRepository(axios);
  const customPlanReportsRepository = CustomPlanReportsRepository(axios);
  const facilityCapacityRepository = FacilityCapacityRepository(axios);
  const tlnkOptionsRepository = TlnkOptionsRepository(axios);
  const mediaSelectorRepository = MediaSelectorRepository(axios);

  return {
    absentUseKind: absentUseKindRepository(`${MANAGER_API_ENDPOINT.ABSENT_USE_KIND}`),
    accountTransferAlert: accountTransferAlertRepository(`${MANAGER_API_ENDPOINT.ACCOUNT_TRANSFER_ALERT}`),
    administrators: administratorsRepository(`${MANAGER_API_ENDPOINT.ADMINISTRATORS}`),
    companyDrivenSetting: companyDrivenSettingRepository(`${MANAGER_API_ENDPOINT.COMPANY_DRIVEN_SETTING}`),
    administratorAttendances: administratorAttendancesRepository(`${MANAGER_API_ENDPOINT.ADMINISTRATOR_ATTENDANCES}`),
    agencies: agenciesRepository(`${MANAGER_API_ENDPOINT.AGENCIES}`),
    agreeToVideoStreamingTerms: agreeToVideoStreamingTermsRepository(
      `${MANAGER_API_ENDPOINT.VIDEO.AGREE_TO_VIDEO_STREAMING_TERMS}`
    ),
    auth: authRepository(`${MANAGER_API_ENDPOINT.LOGIN}`),
    members: membersRepository(`${MANAGER_API_ENDPOINT.MEMBERS}`),
    topics: topicsRepository(`${MANAGER_API_ENDPOINT.TOPICS}`),
    whereaboutsCheckSetting: whereaboutsCheckSettingRepository(`${MANAGER_API_ENDPOINT.WHEREABOUTS_CHECK_SETTING}`),
    topicInsides: topicInsidesRepository(`${MANAGER_API_ENDPOINT.TOPIC_INSIDES}`),
    me: meRepository(`${MANAGER_API_ENDPOINT.ME}`),
    plans: plansRepository(`${MANAGER_API_ENDPOINT.PLANS}`),
    curriculumsPlan: curriculumsPlanRepository(`${MANAGER_API_ENDPOINT.CURRICULUMS_PLAN}`),
    yearsPlan: yearsPlanRepository(`${MANAGER_API_ENDPOINT.YEARS_PLAN}`),
    monthliesPlan: monthliesPlanRepository(`${MANAGER_API_ENDPOINT.MONTHLIES_PLAN}`),
    weekliesPlan: weekliesPlanRepository(`${MANAGER_API_ENDPOINT.WEEKLIES_PLAN}`),
    statuses: planStatusesRepository(`${MANAGER_API_ENDPOINT.STATUSES}`),
    conditions: conditionsRepository(`${MANAGER_API_ENDPOINT.CONDITIONS}`),
    schedules: schedulesRepository(`${MANAGER_API_ENDPOINT.SCHEDULES}`),
    comments: commentsRepository(`${MANAGER_API_ENDPOINT.COMMENTS}`),
    communicationBookDisplayAdministrator: communicationBookDisplayAdministratorRepository(
      `${MANAGER_API_ENDPOINT.COMMUNICATION_BOOK_DISPLAY_ADMINISTRATOR}`
    ),
    categories: categoriesRepository(`${MANAGER_API_ENDPOINT.CATEGORIES}`),
    mealPatterns: mealPatternsRepository(`${MANAGER_API_ENDPOINT.MEAL_PATTERNS}`),
    serviceGroups: serviceGroupsRepository(`${MANAGER_API_ENDPOINT.SERVICE_GROUPS}`),
    serviceOptions: serviceOptionsRepository(`${MANAGER_API_ENDPOINT.SERVICE_OPTIONS}`),
    groups: groupsRepository(`${MANAGER_API_ENDPOINT.GROUPS}`),
    sleepingCondition: sleepingConditionRepository(`${MANAGER_API_ENDPOINT.SLEEPING_CONDITION}`),
    sleepingRemarks: sleepingRemarksRepository(`${MANAGER_API_ENDPOINT.SLEEPING_REMARKS}`),
    roles: roleRepository(`${MANAGER_API_ENDPOINT.ROLES}`),
    facility: facilityRepository(`${MANAGER_API_ENDPOINT.FACILITY}`),
    outsourcing: outsourcingRepository(`${MANAGER_API_ENDPOINT.OUTSOURCING}`),
    accidentReport: accidentReportRepository(`${MANAGER_API_ENDPOINT.ACCIDENTREPORT}`),
    billConfiguration: billConfigurationRepository(`${MANAGER_API_ENDPOINT.BILL_CONFIGURATIONS}`),
    billsTotal: billsTotalRepository(`${MANAGER_API_ENDPOINT.BILLS_TOTAL}`),
    billsConfirm: billsConfirmRepository(`${MANAGER_API_ENDPOINT.BILLS_CONFIRM}`),
    communicationNotebooks: communicationNotebooksRepository(`${MANAGER_API_ENDPOINT.COMMUNICATION_NOTEBOOKS}`),
    topicInside: topicInsideRepositoryImpl(axios)(`${MANAGER_API_ENDPOINT.TOPIC_INSIDE}`),
    personalReports: personalReportsRepositoryImpl(axios)(`${MANAGER_API_ENDPOINT.PERSONAL_REPORTS}`),
    systemTroubleContactSetting: systemTroubleContactSettingRepository(
      `${MANAGER_API_ENDPOINT.SYSTEM_TROUBLE_CONTACT_SETTING}`
    ),
    photoRetailPrice: photoRetailPriceRepository(`${MANAGER_API_ENDPOINT.PHOTO_RETAIL_PRICE}`),
    photoPriceSettingRules: photoPriceSettingRulesRepository(`${MANAGER_API_ENDPOINT.PHOTO_PRICE_SETTING_RULES}`),
    photoBasePrices: photoBasePricesRepository(),
    feature: featureRepository(`${MANAGER_API_ENDPOINT.FEATURE}`),
    customPlanReports: customPlanReportsRepository(`${MANAGER_API_ENDPOINT.CUSTOM_PLAN_REPORTS}`),
    whereaboutsCheckStatus: whereaboutsCheckStatusRepository(axios),
    whereaboutsCheckResult: whereaboutsCheckResultRepository(axios),
    facilityCapacity: facilityCapacityRepository(`${MANAGER_API_ENDPOINT.FACILITY_CAPACITY}`),
    children: ChildrenRepository(axios),
    tlnkOptions: tlnkOptionsRepository(),
    mediaSelector: mediaSelectorRepository(),
  };
};
